"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentTerminalControlCompletedPaymentsSerialization = void 0;
const PaymentTransactionSerialization_1 = require("./PaymentTransactionSerialization");
class PaymentTerminalControlCompletedPaymentsSerialization {
    static serialize(entity) {
        const copy = { ...entity };
        copy.payments = entity.payments?.map((field) => field
            ? JSON.parse(PaymentTransactionSerialization_1.PaymentTransactionSerialization.serialize(field))
            : undefined);
        return JSON.stringify(copy);
    }
    static deserialize(msg) {
        const entity = JSON.parse(msg);
        const copy = { ...entity };
        copy.payments = entity.payments?.map((field) => field
            ? PaymentTransactionSerialization_1.PaymentTransactionSerialization.deserialize(JSON.stringify(field))
            : undefined);
        return copy;
    }
}
exports.PaymentTerminalControlCompletedPaymentsSerialization = PaymentTerminalControlCompletedPaymentsSerialization;
